import type { OrderHistoryResponse } from "@/app/ec/product/[basePath]/purchase-history";

/**
 * Client-side Order History modal payload (RNG-1593) — calls the modern orders service through
 * the same-origin proxy route (/rest/orders/product-purchase-history), which forwards the
 * n32JWT cookie server-side. Keyed by mpId: the orders service resolves the product to ALL of
 * its vendor products (including vendors that stopped selling it) and stitches vendor names,
 * so callers no longer resolve vpIds themselves.
 */
export default async function getPurchaseHistoryClient(mpId: number): Promise<OrderHistoryResponse | null> {
  try {
    const res = await fetch(`/rest/orders/product-purchase-history?mpId=${mpId}`, {
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      cache: "no-store",
    });
    if (!res.ok) {
      return null;
    }
    return (await res.json()) as OrderHistoryResponse;
  } catch (error) {
    console.error(`Error fetching purchase history: ${error}`);
    return null;
  }
}
